import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:apps.ascendChangeImpacts',
    'package:apps.stakeholders',
    // Replaced by the Change360 versions below, which add persona support
    '-resource:solutions.mosaic.actions.changeImpacts.saveChangeImpact',
    '-resource:solutions.mosaic.pages.changeImpacts.dashboard',
    '-resource:solutions.mosaic.widgets.changeImpacts.changeImpactLog',
    '-resource:solutions.mosaic.widgets.changeImpacts.createChangeImpactModal',
    '-resource:solutions.mosaic.widgets.changeImpacts.editChangeImpactModal',
    'resource:data.dimensions.changeImpactPersonas',
    'resource:data.dimensions.changeImpactPersonas.entities.changeImpactPersona',
    'resource:data.dimensions.changeImpactPersonas.entities.changeImpactPersona.attributes.changeImpact',
    'resource:data.dimensions.changeImpactPersonas.entities.changeImpactPersona.attributes.persona',
    'resource:solutions.mosaic.actions.change360.saveChangeImpact',
    'resource:solutions.mosaic.pages.change360.dashboard',
    'resource:solutions.mosaic.widgets.change360.changeImpactLog',
    'resource:solutions.mosaic.widgets.change360.changeImpactsByPersona',
    'resource:solutions.mosaic.widgets.change360.createChangeImpactModal',
    'resource:solutions.mosaic.widgets.change360.editChangeImpactModal',
  ],
  description:
    'A package combining the Change Impacts and Stakeholder Analysis applications in a single zone, linked through personas.',
  name: 'Change360',
} as const satisfies core.quiver.Package
